import React from 'react';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';

interface DeleteIconButtonProps {
  style?: React.CSSProperties;
  onClick: () => void;
}

const DeleteIconButton: React.FC<DeleteIconButtonProps> = ({ onClick, ...props }) => {
  return (
    <IconButton aria-label="delete" onClick={onClick} {...props}>
      <Delete fontSize="small" />
    </IconButton>
  );
};

export default DeleteIconButton;
